"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimentsService = void 0;
var tslib_1 = require("tslib");
var wix_experiments_1 = require("@wix/wix-experiments");
var experimentsInstance;
exports.experimentsService = {
    isExperimentEnabled: function (experimentName) {
        if (!this.getInstance()) {
            console.error("Experiments Service :: isExperimentEnabled('" + experimentName + "') called before initExperiments. Returning false");
            return false;
        }
        return this.getInstance().enabled(experimentName);
    },
    getInstance: function () {
        return experimentsInstance;
    },
    initExperiments: function (instanceOrParams) {
        if (instanceOrParams === void 0) { instanceOrParams = {}; }
        if (instanceOrParams instanceof wix_experiments_1.default) {
            experimentsInstance = instanceOrParams;
        }
        else {
            var experimentsParams = instanceOrParams;
            var initParams = {};
            if (experimentsParams.experiments) {
                initParams.experiments = experimentsParams.experiments;
            }
            else {
                initParams = {
                    baseUrl: experimentsParams.baseUrl || 'https://www.wix.com',
                    scope: experimentsParams.scope || 'cashier',
                    useNewApi: false,
                };
                if (experimentsParams.forSiteVisitors) {
                    initParams.requestContext = initParams.requestContext || {};
                    initParams.requestContext.forSiteVisitors =
                        experimentsParams.forSiteVisitors;
                }
                else if (experimentsParams.forSiteOwner) {
                    initParams.requestContext = initParams.requestContext || {};
                    initParams.requestContext.forSiteOwner =
                        experimentsParams.forSiteOwner;
                }
            }
            experimentsInstance = new wix_experiments_1.default(initParams);
        }
        return experimentsInstance;
    },
    ready: function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!experimentsInstance) {
                            this.initExperiments();
                        }
                        return [4 /*yield*/, experimentsInstance.ready()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, experimentsInstance];
                }
            });
        });
    },
};
//# sourceMappingURL=index.js.map